(() => {
  const widgets=document.getElementById('boreal-header-widgets');
  const hide=document.getElementById('boreal-hide-chat');
  const show=document.getElementById('boreal-show-chat');
  const chatRoot=()=>{ const root=document.querySelector('shopify-chat')?.shadowRoot; return root?.querySelector('shopify-agent-runtime')?.shadowRoot||root; };
  let dismissed=false;
  try { dismissed=sessionStorage.getItem('boreal-chat-collapsed')==='true'; } catch {}
  const apply=()=>{
    document.documentElement.classList.toggle('boreal-chat-hidden',dismissed);
    show.hidden=!dismissed;
    try { sessionStorage.setItem('boreal-chat-collapsed',String(dismissed)); } catch {}
    schedule();
  };
  hide.addEventListener('click',()=>{dismissed=true;apply();show.focus();});
  show.addEventListener('click',()=>{
    dismissed=false;apply();
    requestAnimationFrame(()=>{
      const launcher=chatRoot()?.querySelector('[part~="activator"]');
      if(launcher?.getAttribute('aria-expanded')!=='true')launcher?.click();
    });
  });
  let pending=false;
  let observedRoot;
  let observedLauncher;
  const launcherResizeObserver=new ResizeObserver(()=>schedule());
  const shadowObserver=new MutationObserver(()=>schedule());
  function schedule(){if(!pending){pending=true;requestAnimationFrame(update);}}
  function update(){
    pending=false;
    const actions=Array.from(document.querySelectorAll('.bnp-actions')).find(e=>e.getClientRects().length);
    if(actions&&widgets.parentElement!==actions)actions.prepend(widgets);
    const currency=document.querySelector('.doubly-float');
    if(currency&&currency.parentElement!==widgets)widgets.prepend(currency);
    const host=document.querySelector('shopify-chat');
    const root=chatRoot();
    if(root&&root!==observedRoot){shadowObserver.disconnect();shadowObserver.observe(root,{subtree:true,childList:true,attributes:true});observedRoot=root;}
    const launcher=root?.querySelector('[part~="activator"]');
    if(launcher!==observedLauncher){
      launcherResizeObserver.disconnect();
      observedLauncher?.removeEventListener('transitionend',schedule);
      observedLauncher=launcher;
      if(launcher){launcherResizeObserver.observe(launcher);launcher.addEventListener('transitionend',schedule);}
    }
    const rect=launcher?.getBoundingClientRect();
    const visible=!dismissed&&rect&&rect.width>0&&rect.height>0&&launcher.getAttribute('aria-expanded')!=='true';
    if(hide.hidden===!!visible)hide.hidden=!visible;
    if(visible){
      hide.style.height=rect.height+'px';
      const colors=getComputedStyle(launcher);
      hide.style.backgroundColor=colors.backgroundColor;
      hide.style.color=colors.color;
      const right=Math.max(8,document.documentElement.clientWidth-rect.left-1)+'px';
      const bottom=Math.max(8,innerHeight-rect.bottom)+'px';
      if(hide.style.right!==right)hide.style.right=right;
      if(hide.style.bottom!==bottom)hide.style.bottom=bottom;
    }
  }
  new MutationObserver(schedule).observe(document.body,{subtree:true,childList:true});
  new MutationObserver(schedule).observe(document.documentElement,{attributes:true,attributeFilter:['class']});
  window.addEventListener('resize',schedule);
  window.visualViewport?.addEventListener('resize',schedule);
  window.addEventListener('scroll',schedule,{passive:true});
  document.addEventListener('transitionend',schedule);
  customElements.whenDefined('shopify-chat').then(schedule);
  apply();
})();
(() => {
  const product = document.querySelector('.m-main-product');
  if (!product) return;
  const homes = new Map();
  let slot;
  let queued = false;
  const remember = node => {
    if (!homes.has(node)) {
      const marker = document.createComment('installment-position');
      node.before(marker);
      homes.set(node, marker);
    }
  };
  const update = () => {
    queued = false;
    const checkout = product.querySelector('.main-product__block-buy_buttons shopify-accelerated-checkout');
    const more = checkout?.querySelector('more-payment-options-link');
    const purchaseActions = product.querySelector('.main-product__block-buy_buttons .m-product-form--wrapper');
    if (more || purchaseActions) {
      if (!slot) {
        slot = document.createElement('div');
        slot.className = 'boreal-product-installments';
        slot.slot = 'more-options';
      }
      if (more) {
        if (slot.parentElement !== checkout) more.before(slot);
      } else if (purchaseActions.nextElementSibling !== slot) {
        purchaseActions.after(slot);
      }
      const sezzle = product.querySelector('.main-product__block-price .sezzle-shopify-info-button') || slot.querySelector('.sezzle-shopify-info-button');
      const terms = product.querySelector('shopify-payment-terms');
      [sezzle, terms].filter(Boolean).forEach(node => {
        if (node.parentElement !== slot) { remember(node); slot.append(node); }
      });
    } else {
      homes.forEach((marker, node) => { if (marker.isConnected && node.previousSibling !== marker) marker.after(node); });
      if (slot?.isConnected) slot.remove();
    }
  };
  const schedule = () => { if (!queued) { queued = true; requestAnimationFrame(update); } };
  new MutationObserver(schedule).observe(product, {childList:true, subtree:true});
  schedule();
})();
